import React, { Fragment, useMemo } from "react"
import { withRouter } from "react-router"
import { useSelector } from "react-redux"
import { Card, CardContent, Box } from "@material-ui/core"
import BillApprovalCard from "../../../../../components/Billing/Admin/BillApprovalCard/index"
import ExpenseTableTotal from "../../../../../components/Billing/Common/ExpenseTableTotal/index"
import calculateTotals from "../../../../../utils/calculateTotals"
import NoData from "../../../../../components/Billing/Admin/NoData/index"
import usePaidAmountInvoice from "../../../../../hooks/usePaidAmountInvoice"

const BillApprovalPage = props => {


  let id = props.match.params.shoot_id
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)
  const { discount } = useSelector(state => state.billing.generalData)

  const paidAmt = usePaidAmountInvoice()

  const amounts = useMemo(
    () => {
      return calculateTotals(usersRolesArray, paidAmt, discount)
    },
    [usersRolesArray, discount, paidAmt]
  )

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  return (
    <Box>
      {usersRolesArray.length === 0 ? (
        <NoData />
      ) : (
        usersRolesArray.map((position, i) => {
          return (
            <Fragment key={i}>
              <BillApprovalCard shootId={id} position={position} />
            </Fragment>
          )
        })
      )}

      {usersRolesArray.length > 0 && (
        <Card>
          <CardContent style={{ display: "flex", justifyContent: "flex-end" }}>
            <Box width={viewportWidth > 600 ? "40%" : "100%"}>
              <ExpenseTableTotal
                data={amounts}
                combined
                addDiscount
                discount={discount}
              />
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  )
}
export default withRouter(BillApprovalPage)
